var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-popin-modal2",
    {
      attrs: {
        id: _vm.popinModal.id,
        "aria-labelledby": _vm.popinModal.label,
        "show-close-button": _vm.popinModal.showCloseButton,
      },
    },
    [
      _c("h4", { attrs: { id: "modalTitle" } }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row pt-2 text-center text-md-start" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-6", attrs: { id: "priceBlock" } },
          [
            _c("ob1-prix-offre", {
              attrs: {
                duration: _vm.priceBlock.prixDTO.duration,
                "initial-price": _vm.priceBlock.prixDTO.initialPrice,
                price: _vm.priceBlock.prixDTO.price,
                "price-details": _vm.priceBlock.prixDTO.priceDetails,
                "show-by-month": _vm.priceBlock.prixDTO.showByMonth,
                "show-from": _vm.priceBlock.prixDTO.showFrom,
                "show-promo-duration": _vm.priceBlock.prixDTO.showPromoDuration,
                "price-label": _vm.priceBlock.priceLabel,
                "custom-promo-duration": "text-gray3 d-inline-block",
                "custom-commitment": "text-gray3",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 col-md-6 mt-1",
            attrs: { id: "additionalInfosBlock" },
          },
          _vm._l(_vm.additionalInfosBlock, function (info, index) {
            return _c("div", { key: index }, [
              _c("span", {
                staticClass: "text-gray3 d-block",
                domProps: { innerHTML: _vm._s(info) },
              }),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row pt-2", attrs: { id: "guaranteesBlock" } },
        [_c("guarantees", { attrs: { dto: _vm.guaranteesBlock } })],
        1
      ),
      _vm._v(" "),
      _vm.contractualDocumentsBlock.contractualDocuments.length > 0
        ? _c(
            "div",
            { staticClass: "pt-2", attrs: { id: "contractualDocumentsBlock" } },
            [
              _c("span", {
                staticClass: "mb-1",
                domProps: {
                  innerHTML: _vm._s(_vm.contractualDocumentsBlock.title),
                },
              }),
              _vm._v(" "),
              _c("contractual-documents", {
                attrs: {
                  "contractual-documents":
                    _vm.contractualDocumentsBlock.contractualDocuments,
                  "web-view": _vm.contractualDocumentsBlock.isWebview,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-center my-2 mb-0" },
        [
          _c("ob1-boutons", {
            attrs: {
              label: _vm.buttonLabel,
              "is-button": true,
              "is-disabled": _vm.buttonUrl === null,
              "data-oevent-category": _vm.buttonTrackZone,
              "data-oevent-action": "ajouter_cette_assurance",
              "data-oevent-label": _vm.buttonTrackCible,
              "is-primary": "",
            },
            on: { "ob1-boutons-click": _vm.goToUrl },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }